import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { Subscription } from 'rxjs';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '@infrastructure/TableEdit/TableEditBase';
import { isUndefined, isNullOrUndefined, isNotNullOrUndefinedOrEmpty, isNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import { SecurityService } from '@infrastructure/Security/SecurityService';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';


@Component({
  selector: 'professional-category',
  templateUrl: './professional-category.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => ProfessionalCategoryComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})


export class ProfessionalCategoryComponent implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberType)
  public subscriberTypes: models.DimensionVM[];

  private dropListProfessionalC: models.Options[];
  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;
  public isSubmited = false;
  public expandNewWorkAbroad: boolean = false;
  public expandedRowIndex: number = null;


  //Este campo serve para que se os dados vierem do P21, estes não podem ser editáveis. Se não vierem, então os dados são editáveis
  public preFilledProperties: PreFilledProperty[] = [];


  constructor(private http: HttpClient, private activeRoute: ActivatedRoute,
    private modalService: ModalService, private securityService: SecurityService,
    private commonDataService: CommonDataService,
    private readonly changeDetectorRef: ChangeDetectorRef, private prestacoesMorteValueObserverService: PrestacoesMorteValueObservableService) {

    const domains = [
      DomainCodes.domains,
      DomainCodes.country,
      DomainCodes.yesNo,
      DomainCodes.subscriberType
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.domains = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.domains).dimensions;
          this.countries = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.country).dimensions;
          this.subscriberTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.subscriberType).dimensions;
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }

  public get hasProfessionalCategoryCode(): boolean{
    const result = this.cardData.professionalCategoryCode === undefined; //||       this.cardData.professionalCategoryCode == null;
    return !result;
  }

  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.ProfessionalCategoryVM {
    return this._cardData;
  }
  public set cardData(value: models.ProfessionalCategoryVM) {
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.ProfessionalCategoryVM = {} as models.ProfessionalCategoryVM;

  public parentWorkflow: WorkflowComponentNew;

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
    this.isSubmited = this.parentWorkflow.stateCode == 'C' && this.parentWorkflow.statePhase == 'C';
  }

  ngOnInit(): void {
    if (isNullOrUndefined(this.cardData.workedAbroadList)) {
      this.cardData.workedAbroadList = [];
    }
    if (this.cardData.SSPensionist?.toString() == 'true') {
      this.cardData.SSDiscounts = true;
    }

    this.dropListProfessionalC =this.parentWorkflow.workflowDropdowns.options
      .filter(el => el.dropdown === "dropListProfessionalC");

    if (this.cardData.subscriberType == null || this.cardData.subscriberType == undefined) {
      this.cardData.professionalCategoryCode = null;
    }
      // A prova de efectividade mudou a regra, já não pode ser obtida aqui, mas nos beneficiarios
    //const provaEfectividadeValidation = this.prestacoesMorteValueObserverService
    //  .provaEfetividadeValidation(this.cardData.hadPensionCGABeforeDeath, this.cardData.lastService);

    //    this.prestacoesMorteValueObserverService
    //      .changeProvaEfetividadeNotification(
    //        this.parentWorkflow.workflowInstance.StepDeceased.DeceasedIdentification.subscriberName,
    //        this.parentWorkflow.workflowInstance.StepDeceased.DeceasedIdentification.NIF,
    //        provaEfectividadeValidation);

  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously


    //if (this.cardData.hasWorkedAbroad?.toString() == 'false') {
    //  this.expandNewWorkAbroad = false
    //}
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  public subscriberTypeCodeChanged() {
    let result = [];
    //for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
    //  if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListProfessionalC' && this.cardData?.subscriberType=== this.parentWorkflow.workflowDropdowns.options[i]?.type) {
    //    result.push(this.parentWorkflow.workflowDropdowns.options[i]);
    //  }
    //}
    result = this.parentWorkflow.workflowDropdowns.options
      .filter(el => el.dropdown === "dropListProfessionalC" && this.cardData?.subscriberType === el.type);

    this.dropListProfessionalC = result;


    if (this.cardData.subscriberType == null || this.cardData.subscriberType == undefined) {
      this.cardData.professionalCategoryCode = null;
    }
  }

  onSSPensionistChanged() {
    if (this.cardData.SSPensionist?.toString() == 'true') {
      this.cardData.SSDiscounts = true;
    } else {
      this.cardData.SSDiscounts = null;
    }
    this.isPensionUnified();
  }

  private onCardDataChanged() {
    this.cardData.beneficiaryNumber = this.parentWorkflow.workflowInstance.StepDeceased?.ProfessionalCategory?.beneficiaryNumber;
    this.preFilledProperties.push({ name: "beneficiaryNumber", preFilledValue: this.cardData.beneficiaryNumber, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.beneficiaryNumber) });
  }




  onWorkAbroadChanged(newWorkAbroadList: models.WorkAbroadPMVM[]) {
    this.cardData.workedAbroadList = newWorkAbroadList;
    this.expandedRowIndex = null;
    this.expandNewWorkAbroad = false;
  }

  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }



  public lastServiceRequired(): boolean {
    const option1 = this.cardData.hadPensionCGABeforeDeath?.toString() == 'false' &&
      isNotNullOrUndefinedOrEmpty(this.cardData.lastService);
    const option2 = this.cardData.hadPensionCGABeforeDeath?.toString() == 'false' &&
      isNullOrUndefinedOrEmpty(this.cardData.lastService);
    const result = option1 || option2;
    return result;

  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  public hasWorkedAbroadChanged() {
    this.cardData.workedAbroadList = [];
  }

  public isPensionUnified() {
    let result = this.cardData.hadPensionCGABeforeDeath?.toString() == 'false';
    result = result && this.cardData.SSPensionist?.toString() == 'false';
    result = result && this.cardData.SSDiscounts?.toString() == 'true';
    if (result) {
      this.cardData.unifiedPension = null;
    } else {
      this.cardData.unifiedPension = null;
    }
  }

  public resetCategoriaProfissional(): void {
    this.cardData.professionalCategoryCode = null;
    }

  public isHadPensionCGABeforeDeathDisabled(): boolean {
    return this.cardData.hadPensionCGABeforeDeathFlag?.toString() == 'true';
    }
}

